import script from "./CreateProduct.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateProduct.vue?vue&type=script&setup=true&lang=ts"

import "./CreateProduct.vue?vue&type=style&index=0&id=1a5e54bc&lang=scss"

const __exports__ = script;

export default __exports__